import { Link, useLocation } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import logo from '../assets/images/renis_logo.jpg'; // Adjust the path as necessary
import MobileMenu from "./mobilemenu";
import redirectToDonation from "./donationRedirect";

const Navigation = () => {
  const location = useLocation();
  const navRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const el = navRef.current;
    if (!el) return;

    const update = () => setHeight(Math.ceil(el.getBoundingClientRect().height));
    update();

    const onScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', update);
    };
  }, []);

  const navStyle = {
    backgroundColor: scrolled ? '#ffffff' : 'transparent',
    transition: 'background-color 160ms ease',
  };

  const linkStyle = {
    color: scrolled ? '#111' : '#fff',
  };

  const normalize = (p) => {
    if (!p) return '/';
    try {
      p = decodeURIComponent(p);
    } catch (e) {
      // ignore invalid sequences
    }
    return p.replace(/\/+$/g, '').toLowerCase() || '/';
  };

  const isActive = (targetPath, aliases = []) => {
    const p = normalize(location.pathname);
    const t = normalize(targetPath);
    if (t === '/home') return p === '/' || p === '/home';
    if (p === t || p.startsWith(t + '/')) return true;
    for (const a of aliases) {
      const na = normalize(a);
      if (p === na || p.startsWith(na + '/')) return true;
    }
    return false;
  };

  const getLinkStyle = (targetPath) => {
    if (isActive(targetPath)) return { color: 'var(--primary)' };
    return linkStyle;
  };

  return (
    <>
      <nav ref={navRef} className={`web-menu max-width2 ${scrolled ? 'scrolled' : ''}`} style={navStyle}>
        <Link to="/" >
          <img src={logo} alt="" className="nav-logo" />
        </Link>
        <div className="nav-menu hide-mobile">
          <Link to="/home" className={`nav-menu-link ${isActive('/home') ? 'active' : ''}`} style={getLinkStyle('/home')}>Home</Link>
          <Link to="/about" className={`nav-menu-link ${isActive('/about') ? 'active' : ''}`} style={getLinkStyle('/about')}>About Me</Link>
          <Link to="/ren on issue" className={`nav-menu-link ${isActive('/ren on issue') ? 'active' : ''}`} style={getLinkStyle('/ren on issue')}>Ren On Issues</Link>
          <Link to="/events/" className={`nav-menu-link ${isActive('/events', ['/event-details']) ? 'active' : ''}`} style={getLinkStyle('/events')}>Events</Link>
          <Link to="/media/" className={`nav-menu-link ${isActive('/media') ? 'active' : ''}`} style={getLinkStyle('/media')}>Media</Link>
          <Link to="/news/" className={`nav-menu-link ${isActive('/news') ? 'active' : ''}`} style={getLinkStyle('/news')}>News</Link>
          <Link to="/ContactUs" className={`nav-menu-link ${isActive('/ContactUs') ? 'active' : ''}`} style={getLinkStyle('/ContactUs')}>Contact</Link>
          <Link to="/sms-opt-in" className={`nav-menu-link ${isActive('/sms-opt-in') ? 'active' : ''}`} style={getLinkStyle('/sms-opt-in')}>Text Updates</Link>
        </div>

        <div className="show-mobile">
          <MobileMenu />
        </div>

        <div className="nav-menu hide-mobile">
          <button
            className="btn-primary-primary"
            onClick={redirectToDonation}
            style={{ background: scrolled ? 'var(--primary)' : undefined, color: scrolled ? '#fff' : undefined }}
          >
            Donate Now
          </button>
        </div>
      </nav>
      {/* spacer to avoid content jump when nav is fixed by outer wrapper */}
      <div aria-hidden="true" style={{ height }} />
    </>
  );
}

export default Navigation;